import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { AddVideoPanelContent } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { AdsStudioAddAssetPanel } from './add-asset-panel';
import { getAddVideoError } from './error/add-video-error';

export const AddVideoPanel = (props) => {
  const {
    i18n, dataService, aid,
    logger, notificationApi, navigation, open,
  } = props;
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [showBlocker, setShowBlocker] = useState(false);

  const dismiss = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  const onClickSelect = useCallback(() => {
    const videoUrl = selectedVideos[0].url;
    setShowBlocker(true);
    dataService.uploadVideoByUrl({
      videoUrl,
    }).then((videoId) => {
      logger.logTrace('Add Media Panel: saved video to folder', { videoId });

      navigation.goBack({ reload: true });
    }).catch((error) => {
      const errorMsg = getAddVideoError({
        error,
        i18n,
        aid,
        logger,
      });
      notificationApi.showWarning(errorMsg);

      dismiss();
    }).finally(() => {
      setShowBlocker(false);
    });
  }, [aid, dataService, dismiss, i18n, logger, navigation, notificationApi, selectedVideos]);

  const onChange = useCallback((videos) => {
    setSelectedVideos(videos);
  }, []);

  return (
    <AdsStudioAddAssetPanel
      aid={aid}
      i18n={i18n}
      dismiss={dismiss}
      isOpen={open}
      showBlocker={showBlocker}
      selectedAsset={selectedVideos}
      headerText={i18n.getString(_TL_('Add video URL'))}
      logger={logger}
      notificationApi={notificationApi}
      onClickSelect={onClickSelect}
    >
      <AddVideoPanelContent i18n={i18n} onChange={onChange} />
    </AdsStudioAddAssetPanel>
  );
};
AddVideoPanel.propTypes = {
  aid: PropTypes.number.isRequired,
  i18n: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({ gotoImagesPage: PropTypes.func }).isRequired,
  dataService: PropTypes.shape({
    uploadVideoByUrl: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  notificationApi: PropTypes.shape({
    showWarning: PropTypes.func,
  }).isRequired,
  open: PropTypes.bool.isRequired,
};
